export enum MultiSiteDashboardCard {
  SiteFleetsOverview = 'siteFleetsOverview',
  EnergyCostOverview = 'energyCostOverview',
  SiteAlerts = 'siteAlerts',
  ChargersOverview = 'chargersOverview',
  VehicleStateOfChargeSummary = 'vehicleStateOfChargeSummary',
}
